import React from 'react'
import { ChatbotStepActionData, ResetVariableActionData } from '../../../../models/flowBuilderTypes'
import formStyles from './../../../../assets/styles/componentStyles/manychatStyles/workflowFormComponents/workflowForm.module.scss'
import { useFlowBuilderStore } from '../../../../store/flowBuilderStore'

const ResetVariableNode = ({ id, data }: { id: string, data: ChatbotStepActionData<ResetVariableActionData> }) => { 
    const customVariableList = useFlowBuilderStore((state) => state.customVariableList)

    const isConfigureResetData = (data: ChatbotStepActionData<ResetVariableActionData>) => {
        return !data?.action_data?.flag_reset_all_custom_variable && data?.action_data?.reset_custom_variable?.length == 0;
    }

    const getCustomResetConfiguredVariables = () => {
        return customVariableList?.custom_variable_data?.filter((variable) => data?.action_data?.reset_custom_variable?.find((resetVar: any) => resetVar?.reset_custom_variable_id == variable.chatbot_custom_variable_configuration_id))?.map((variable) => variable?.chatbot_custom_variable_name)?.join(", ");
    }

    return (
        <>
            { 
                //@ts-ignore
                (isConfigureResetData(data)) ?
                    <>
                        <div>
                            <span className={formStyles.dataSavedTextStyle}>
                                {`Reset Data `}
                            </span>
                            <span className={formStyles.dataSavedValueStyle}>
                                {`Please Configure Reset Variable*`}    
                            </span>
                        </div>
                    </>
                    :
                    <>  
                        <div>
                            <span className={formStyles.dataSavedTextStyle}>
                                {`Reset Data`}
                            </span>
                            <span className={formStyles.dataSavedValueStyle}>
                                {data?.action_data?.flag_reset_all_custom_variable ? 
                                    "Reset All Variable" 
                                    : 
                                    getCustomResetConfiguredVariables()
                                }
                            </span>
                        </div>
                    </>
            }
        </>
    )
}

export default ResetVariableNode
